export default __webpack_public_path__ + "static/video-image-01-570x420-86000e20a9a2d379bc91694b27026834.jpg";